export * from "./nodeMaterialOptimizer.js";
//# sourceMappingURL=index.js.map